import { Model, hasMany } from 'miragejs';

export default Model.extend({
  registrationDates: hasMany('graphql/registration-date-partial-day'),
});
